/* @flow */

import * as React from 'react';
import { position } from 'polished';
import glamorous from 'glamorous';
import { css } from 'glamor';

type Props = {
  children: any,
  height: number,
  width: number,
};

const ImageCarouselWrapper = glamorous.div(props => ({
  margin: '0 auto',
  paddingTop: `${100 * props.height / props.width}%`,
  position: 'relative',
}));

const ImageCarouselItem = glamorous.div(({ index, total }) => ({
  animationDuration: `${total * 12}s`,
  animationIterationCount: 'infinite',
  animationName: css.keyframes({
    [`${100 * ((index - 0.1) / total)}%`]: { opacity: 0, zIndex: 0 },
    [`${100 * (index / total)}%`]: { opacity: 1, zIndex: 1 },
    [`${100 * ((index + 1) / total)}%`]: { opacity: 1, zIndex: 1 },
    [`${100 * ((index + 1.1) / total)}%`]: { opacity: 0, zIndex: 0 },
  }),
  opacity: 0,
  ...position('absolute', 0),
}));

function ImageCarousel({ children, height, width }: Props) {
  const total = React.Children.count(children);

  return (
    <ImageCarouselWrapper height={height} width={width}>
      {React.Children.map(children, (child, i) => (
        <ImageCarouselItem key={i} index={i} total={total}>
          {React.cloneElement(child, {
            style: {
              height: 'auto',
              width: '100%',
            },
          })}
        </ImageCarouselItem>
      ))}
    </ImageCarouselWrapper>
  );
}

export default ImageCarousel;
